import React, {Component} from 'react'
import Link from "next/link"
import {Carousel} from 'react-responsive-carousel';
import moment from "moment"
import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"

export default class CardImage extends Component{

    render(){
        const {org}=this.props.context

        const item=this.props.item
        const link=this.props.link

        var cover=(<img src={item.images[0]} style={{height:400,width:"100%",objectFit:"cover"}}/> )

        if(item.images.length>1){
            cover=(
                <Carousel infiniteLoop autoPlay showThumbs={false} statusFormatter={(current,total)=>t`${current} sur ${total}`}>
                    {item.images.map(i=><img src={i} style={{height:400,width:"100%",objectFit:"cover"}}/>)}
                </Carousel>
            )
        }

        var finalLink=link
        if(item.link){
            finalLink=item.link
        }


        return (
            <div className="post format-standard-image">
                <div className="entry-media">
                    {cover}
                </div>
                <ul className="entry-meta">
                    <li><Link href={finalLink}><span style={{textTransform:"uppercase",cursor:"pointer"}}> {org.contact.prenom} {org.contact.nom}</span></Link></li>
                    <li><Link href={finalLink}>{moment(item.datetime).format("DD MMM YYYY")}</Link></li>
                </ul>
                <h3><Link href={finalLink}>{item.title}</Link></h3>
                <p>{item.description}</p>
                <div className="entry-bottom">
                    <Link href={finalLink}>
                        <span className="read-more"><Trans>Voir Plus...</Trans></span>
                    </Link>
                </div>
                {Array.isArray(item.thematiques) && item.thematiques.length>0 &&(
                    <div className="blog-thumb-badge">
                        <div className="blog-thumb-text">
                            <span>{item.thematiques[0]}</span>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}
